module.exports = __webpack_public_path__ + "static/media/to.cccdba4c.svg";